(function () {
  'use strict';

  var STORAGE_KEY = 'bothanica:wishlist:v1';
  var TOAST_DURATION = 3800;
  var toastRegion;

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function (item) { return item && item.handle; }) : [];
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      return false;
    }

    window.dispatchEvent(new CustomEvent('bothanica:wishlist:updated', { detail: { items: items } }));
    return true;
  }

  function getProductFromButton(button) {
    return {
      handle: button.dataset.wishlistHandle || '',
      title: button.dataset.wishlistTitle || '',
      url: button.dataset.wishlistUrl || '',
      featured_image: button.dataset.wishlistImage || '',
      price: button.dataset.wishlistPrice || '',
      compare_at_price: button.dataset.wishlistCompareAtPrice || '',
    };
  }

  function normalizeWishlistImage(url) {
    if (!url) return '';

    try {
      var parsed = new URL(url, window.location.origin);
      if (!/cdn\/shop|shopifycdn/i.test(parsed.hostname + parsed.pathname)) return url;
      parsed.searchParams.set('width', '520');
      parsed.searchParams.set('height', '520');
      parsed.searchParams.set('crop', 'center');
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function isWishlisted(handle, items) {
    return items.some(function (item) { return item.handle === handle; });
  }

  function updateButton(button, active) {
    var title = button.dataset.wishlistTitle || 'produto';
    var label = active
      ? 'Remover ' + title + ' da Lista de Desejos'
      : 'Adicionar ' + title + ' à Lista de Desejos';
    var visualLabel = button.querySelector('[data-wishlist-button-label]');

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', label);

    if (visualLabel) {
      visualLabel.textContent = active ? 'Remover da Lista de Desejos' : 'Adicionar à Lista de Desejos';
    }
  }

  function syncButtons() {
    var items = getWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      updateButton(button, isWishlisted(button.dataset.wishlistHandle, items));
    });
    updateHeaderCount(items);
  }

  function updateHeaderCount(items) {
    var list = items || getWishlist();
    var next = String(list.length);
    document.querySelectorAll('[data-wishlist-count]').forEach(function (bubble) {
      var label = bubble.querySelector('span');
      var prev = bubble.getAttribute('data-count');
      if (label) label.textContent = next;
      if (list.length > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', '');
      }
      // Efeito de "pulinho" quando o número muda (reusa cart-bubble-pop)
      if (prev !== null && prev !== next && list.length > 0) {
        bubble.classList.remove('is-bumped');
        void bubble.offsetWidth; // força reflow para reiniciar a animação
        bubble.classList.add('is-bumped');
      }
      bubble.setAttribute('data-count', next);
    });
  }

  function ensureToastRegion() {
    if (toastRegion && document.body.contains(toastRegion)) return toastRegion;

    toastRegion = document.createElement('div');
    toastRegion.className = 'wishlist-toast-region';
    toastRegion.setAttribute('aria-live', 'polite');
    toastRegion.setAttribute('aria-atomic', 'true');
    document.body.appendChild(toastRegion);

    return toastRegion;
  }

  function closeToast(toast) {
    toast.classList.add('is-leaving');
    window.setTimeout(function () {
      toast.remove();
    }, 190);
  }

  function showToast(product, message) {
    var region = ensureToastRegion();
    var toast = document.createElement('div');
    var image = document.createElement('img');
    var content = document.createElement('div');
    var title = document.createElement('strong');
    var text = document.createElement('p');
    var close = document.createElement('button');

    toast.className = 'wishlist-toast';
    image.className = 'wishlist-toast__image';
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';

    if (product.featured_image) {
      image.src = product.featured_image;
    } else {
      image.hidden = true;
      toast.style.gridTemplateColumns = 'minmax(0, 1fr) 3.2rem';
    }

    content.className = 'wishlist-toast__content';
    title.className = 'wishlist-toast__title';
    title.textContent = product.title || 'Produto';
    text.className = 'wishlist-toast__message';
    text.textContent = message;

    close.className = 'wishlist-toast__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Fechar aviso da Lista de Desejos');
    close.textContent = 'X';
    close.addEventListener('click', function () {
      closeToast(toast);
    });

    content.appendChild(title);
    content.appendChild(text);
    toast.appendChild(image);
    toast.appendChild(content);
    toast.appendChild(close);
    region.prepend(toast);

    window.setTimeout(function () {
      if (document.body.contains(toast)) closeToast(toast);
    }, TOAST_DURATION);
  }

  function toggleWishlist(button) {
    var product = getProductFromButton(button);
    if (!product.handle) return;

    var items = getWishlist();
    var exists = isWishlisted(product.handle, items);
    var nextItems;

    if (exists) {
      nextItems = items.filter(function (item) { return item.handle !== product.handle; });
    } else {
      nextItems = [product].concat(items.filter(function (item) { return item.handle !== product.handle; }));
    }

    if (!setWishlist(nextItems)) return;

    syncButtons();
    renderWishlistPage();
    showToast(product, exists ? 'Produto removido da Lista de Desejos' : 'Adicionado à Lista de Desejos');
  }

  function handleClick(event) {
    var button = event.target.closest('[data-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(button);
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var items = getWishlist();

    if (!grid || !empty) return;

    grid.innerHTML = '';
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;

    items.forEach(function (item) {
      var card = document.createElement('article');
      var media = document.createElement('a');
      var image = document.createElement('img');
      var body = document.createElement('div');
      var title = document.createElement('h2');
      var titleLink = document.createElement('a');
      var price = document.createElement('div');
      var actions = document.createElement('div');
      var cta = document.createElement('a');
      var remove = document.createElement('button');

      card.className = 'wishlist-card';

      media.className = 'wishlist-card__media';
      media.href = item.url || '#';
      media.setAttribute('aria-label', item.title || 'Produto');

      image.className = 'wishlist-card__image';
      image.alt = item.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      if (item.featured_image) {
        image.src = normalizeWishlistImage(item.featured_image);
      } else {
        image.hidden = true;
      }
      media.appendChild(image);

      body.className = 'wishlist-card__body';
      title.className = 'wishlist-card__title';
      titleLink.href = item.url || '#';
      titleLink.textContent = item.title || 'Produto';
      title.appendChild(titleLink);

      price.className = 'wishlist-card__price';
      if (item.compare_at_price) {
        var compare = document.createElement('span');
        compare.className = 'wishlist-card__compare';
        compare.textContent = item.compare_at_price;
        price.appendChild(compare);
      }

      var current = document.createElement('span');
      current.className = 'wishlist-card__current';
      current.textContent = item.price || '';
      price.appendChild(current);

      actions.className = 'wishlist-card__actions';
      cta.className = 'wishlist-card__cta';
      cta.href = item.url || '#';
      cta.textContent = 'Ver produto';

      remove.className = 'wishlist-card__remove';
      remove.type = 'button';
      remove.textContent = 'Remover';
      remove.setAttribute('aria-label', 'Remover ' + (item.title || 'produto') + ' da Lista de Desejos');
      remove.addEventListener('click', function () {
        var nextItems = getWishlist().filter(function (storedItem) {
          return storedItem.handle !== item.handle;
        });
        setWishlist(nextItems);
        syncButtons();
        renderWishlistPage();
        showToast(item, 'Produto removido da Lista de Desejos');
      });

      actions.appendChild(cta);
      actions.appendChild(remove);
      body.appendChild(title);
      body.appendChild(price);
      body.appendChild(actions);
      card.appendChild(media);
      card.appendChild(body);
      grid.appendChild(card);
    });
  }

  function initWishlist() {
    syncButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('DOMContentLoaded', initWishlist);
  document.addEventListener('shopify:section:load', initWishlist);
  window.addEventListener('bothanica:wishlist:updated', syncButtons);
})();
